module.exports = __webpack_public_path__ + "img/icon-quest.b70fe52c.svg";